import { render, staticRenderFns } from "./ControversyDocumentAdd.vue?vue&type=template&id=70307845&scoped=true"
import script from "./ControversyDocumentAdd.vue?vue&type=script&lang=js"
export * from "./ControversyDocumentAdd.vue?vue&type=script&lang=js"
import style0 from "./ControversyDocumentAdd.vue?vue&type=style&index=0&id=70307845&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70307845",
  null
  
)

export default component.exports